import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AppRoutes } from '../../enums/app-routes';

@Injectable()
export class NotAuthGuard implements CanActivate {
  public constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const authenticated = this.authService.authenticated$.value;
    if (authenticated) {
      this.router.navigate([AppRoutes.home]);
    }

    return !authenticated;
  }
}
